"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for ToggleButton control
         */
        var ToggleButton = /** @class */ (function (_super) {
            __extends(ToggleButton, _super);
            function ToggleButton() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            /**
             * The click event handler.
             */
            ToggleButton.prototype.Clicked = function (evt) {
                var _this = this;
                if ($dyn.value(this.Enabled)) {
                    var executeClick = function () {
                        // If the new control requires up to date information about last focused control outside action pane
                        if (_this.Root && _this.Root.updateLastClientSelectedControl && $dyn.value(_this.RequiresSelectedControl)) {
                            _this.Root.updateLastClientSelectedControl();
                        }
                        _this.Toggled = !_this.Toggled;
                        $dyn.callFunction(_this.SetToggled, _this, [_this.Toggled]);
                        $dyn.callFunction(_this.Click, _this, evt);
                    };
                    if ($dyn.value(this.SaveRecord)) {
                        if (this.Root && this.Root.AllowSave) {
                            this.Root.AllowSave(executeClick);
                        }
                        else {
                            executeClick();
                        }
                    }
                    else {
                        executeClick();
                    }
                }
                else if (evt) {
                    evt.preventDefault();
                }
            };
            return ToggleButton;
        }($dyn.controls.Button));
        controls.ToggleButton = ToggleButton;
        // Set default values on the prototype for backwards compatibility
        ToggleButton.prototype.template = "Button";
        ToggleButton.prototype.SetToggled = null;
        $dyn.ui.addPropertiesToPrototype(ToggleButton.prototype, {
            Toggled: { defaultValue: false, observable: true },
            Command: { defaultValue: "", observable: true },
            // TODO: Delete?
            Data: { defaultValue: "", observable: true },
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ToggleButton.js.map
